import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type PoliticalViewsMultiSelectInput_query$key } from '@/__generated__/PoliticalViewsMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type PoliticalViewsMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: PoliticalViewsMultiSelectInput_query$key | null | undefined
}

export const PoliticalViewsMultiSelectInput = forwardRef<MultiSelectInputRef, PoliticalViewsMultiSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment PoliticalViewsMultiSelectInput_query on Query {
          politicalViews(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <MultiSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.politicalViews?.nodes, (politicalView) => ({
              label: politicalView!.name,
              value: politicalView!.rowId
            })),
          [queryData?.politicalViews?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

PoliticalViewsMultiSelectInput.displayName = 'PoliticalViewsMultiSelectInput'
